import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

import heartGray from 'src/assets/heartGray.svg'
import heartYellow from 'src/assets/heartYellow.svg'

const COMPLIMENT_ICON_SIZE = 72
const COMPLIMENT_PLACEHOLDER_SIZE = 51

export const classes = {
  root: css`
    cursor: pointer;
    margin: 0 ${theme.spacing(1)}px;
    width: 25%;
  `,
  label: css`
    text-align: center;
    display: block;
    width: 100%;
  `,
  imageDefault: css`
    width: ${COMPLIMENT_ICON_SIZE}px;
    height: ${COMPLIMENT_ICON_SIZE}px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: '';
      width: ${COMPLIMENT_PLACEHOLDER_SIZE}px;
      height: ${COMPLIMENT_PLACEHOLDER_SIZE}px;
      background: url('${heartGray}') no-repeat 50% calc(50% + 2px) #f1efed;
      border-radius: 50%;
    }
    > img {
      display: none;
      margin: auto;
      height: 100%;
    }
  `,
  imageDefaultSelected: css`
    &::before {
      background-image: url('${heartYellow}');
      background-color: transparent;
    }
  `,
  imageCustom: css`
    &::before {
      display: none;
    }
  `,
  visible: css`
    display: block !important;
  `,
}
